import { CreateInstitutionModalTranslations } from "./types";

export const enTranslations: CreateInstitutionModalTranslations = {
    title: "Create Institution",
    name: "Name",
    createButtonText: "Create",
};
